<div class="container">
    <h2>Kopia zapasowa</h2>
    <button (click)="getBackup()">Pobierz kopię zapasową</button>

    <h2>Importuj kopie zapasowa</h2>
    <input type="file" (change)="onFileSelected($event)" />
    <button *ngIf="selectedFile != null" (click)="uploadBackup()">Wgraj plik backupu</button>
</div>
